import { FormatDate } from '@/components/smartUtils/time/FormatDate'

interface Props {
  children: string
}

export function DateValue(props: Props) {
  const { children } = props

  return <FormatDate source={children}></FormatDate>
}
